"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    staticClass: "list-applications-page",
    attrs: {
      menu: _vm.menuItems.children,
      "sub-menu": _vm.menuItems.subMenu,
      "return-menu": "/farm-management/dashboard"
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h2", {
    staticClass: "header-title"
  }, [_vm._v("\n        Estatísticas\n      ")])]), _vm._v(" "), _c("div", {
    staticClass: "info-boxes"
  }, [_c("div", {
    staticClass: "info-box"
  }, [_c("div", {
    staticClass: "info-box-content"
  }, [_c("h3", {
    staticClass: "info-title"
  }, [_vm._v("\n            Lotes\n          ")]), _vm._v(" "), _c("p", {
    staticClass: "info-number"
  }, [_vm._v("\n            " + _vm._s(_vm.dashboardData.lotes) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "info-box"
  }, [_c("div", {
    staticClass: "info-box-content"
  }, [_c("h3", {
    staticClass: "info-title"
  }, [_vm._v("\n            Setores\n          ")]), _vm._v(" "), _c("p", {
    staticClass: "info-number"
  }, [_vm._v("\n            " + _vm._s(_vm.dashboardData.setores) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "info-box"
  }, [_c("div", {
    staticClass: "info-box-content"
  }, [_c("h3", {
    staticClass: "info-title"
  }, [_vm._v("\n            Aplicações pendentes\n          ")]), _vm._v(" "), _c("p", {
    staticClass: "info-number"
  }, [_vm._v("\n            " + _vm._s(_vm.dashboardData.aplicacoesPendentes) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "info-box",
    class: {
      "overdue-alert": _vm.dashboardData.aplicacoesAtraso > 0
    }
  }, [_c("div", {
    staticClass: "info-box-content"
  }, [_c("h3", {
    staticClass: "info-title"
  }, [_vm._v("\n            Aplicações em atraso\n          ")]), _vm._v(" "), _c("p", {
    staticClass: "info-number"
  }, [_vm._v("\n            " + _vm._s(_vm.dashboardData.aplicacoesAtraso) + "\n          ")])])])]), _vm._v(" "), _c("div", {
    staticClass: "dashboard-section"
  }, [_c("div", {
    staticClass: "filters-section"
  }, [_c("div", {
    staticClass: "field is-grouped"
  }, [_c("div", {
    staticClass: "control"
  }, [_c("b-field", {
    attrs: {
      label: "Categorias"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione uma categoria"
    },
    on: {
      input: _vm.applyFilters
    },
    model: {
      value: _vm.filters.categoriasSelecionadas,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "categoriasSelecionadas", $$v);
      },
      expression: "filters.categoriasSelecionadas"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                  Todas as categorias\n                ")]), _vm._v(" "), _vm._l(_vm.categorias, function (categoria) {
    return _c("option", {
      key: categoria.value,
      domProps: {
        value: categoria.value
      }
    }, [_vm._v("\n                  " + _vm._s(categoria.label) + "\n                ")]);
  })], 2)], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "control"
  }, [_c("b-field", {
    attrs: {
      label: "Setores"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione um setor"
    },
    on: {
      input: _vm.applyFilters
    },
    model: {
      value: _vm.filters.setoresSelecionados,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "setoresSelecionados", $$v);
      },
      expression: "filters.setoresSelecionados"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                  Todos os setores\n                ")]), _vm._v(" "), _vm._l(_vm.setores, function (setor) {
    return _c("option", {
      key: setor.id,
      domProps: {
        value: setor.id
      }
    }, [_vm._v("\n                  " + _vm._s(setor.name) + "\n                ")]);
  })], 2)], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "control"
  }, [_c("b-field", {
    attrs: {
      label: "Período"
    }
  }, [_c("b-select", {
    on: {
      input: _vm.applyQuickFilter
    },
    model: {
      value: _vm.filters.quickFilter,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "quickFilter", $$v);
      },
      expression: "filters.quickFilter"
    }
  }, _vm._l(_vm.quickFilters, function (filter) {
    return _c("option", {
      key: filter.value,
      domProps: {
        value: filter.value
      }
    }, [_vm._v("\n                  " + _vm._s(filter.label) + "\n                ")]);
  }), 0)], 1)], 1), _vm._v(" "), _vm.filters.quickFilter === "custom" ? _c("div", {
    staticClass: "control"
  }, [_c("b-field", {
    attrs: {
      label: "Data inicial"
    }
  }, [_c("b-datepicker", {
    attrs: {
      placeholder: "Data inicial",
      "mobile-native": false
    },
    on: {
      input: _vm.applyFilters
    },
    model: {
      value: _vm.filters.startDate,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "startDate", $$v);
      },
      expression: "filters.startDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm.filters.quickFilter === "custom" ? _c("div", {
    staticClass: "control"
  }, [_c("b-field", {
    attrs: {
      label: "Data final"
    }
  }, [_c("b-datepicker", {
    attrs: {
      placeholder: "Data final",
      "mobile-native": false
    },
    on: {
      input: _vm.applyFilters
    },
    model: {
      value: _vm.filters.endDate,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "endDate", $$v);
      },
      expression: "filters.endDate"
    }
  })], 1)], 1) : _vm._e()])]), _vm._v(" "), _c("div", {
    staticClass: "dashboard-content"
  }, [_c("div", {
    staticClass: "chart-section"
  }, [_c("div", {
    staticClass: "chart-container"
  }, [_vm.chartData && _vm.chartData.labels ? _c("bar-chart", {
    attrs: {
      "chart-data": _vm.chartData,
      options: _vm.chartOptions
    }
  }) : _c("div", {
    staticClass: "loading-chart"
  }, [_vm._v("\n              Carregando gráfico...\n            ")])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "list-section"
  }, [_c("h3", {
    staticClass: "subtitle"
  }, [_vm._v("\n            Aplicações "), _c("span", {
    staticClass: "filtered-text"
  }, [_vm._v("filtradas")])]), _vm._v(" "), _c("div", {
    staticClass: "filtered-applications-section"
  }, [_c("div", {
    staticClass: "filtered-info-boxes"
  }, [_c("div", {
    staticClass: "filtered-info-box"
  }, [_c("div", {
    staticClass: "filtered-info-content"
  }, [_c("span", {
    staticClass: "filtered-info-title"
  }, [_vm._v("Aplicações pendentes")]), _vm._v(" "), _c("transition", {
    attrs: {
      name: "fade",
      mode: "out-in"
    }
  }, [!_vm.isLoadingFiltered ? _c("span", {
    key: "number",
    staticClass: "filtered-info-number"
  }, [_vm._v(_vm._s(_vm.filteredPendingApplications))]) : _c("span", {
    key: "loading",
    staticClass: "filtered-info-loading"
  }, [_c("i", {
    staticClass: "fas fa-spinner fa-spin"
  })])])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "filtered-info-box",
    class: {
      "overdue-alert": _vm.filteredOverdueApplications > 0 && !_vm.isLoadingFiltered
    }
  }, [_c("div", {
    staticClass: "filtered-info-content"
  }, [_c("span", {
    staticClass: "filtered-info-title"
  }, [_vm._v("Aplicações em atraso")]), _vm._v(" "), _c("transition", {
    attrs: {
      name: "fade",
      mode: "out-in"
    }
  }, [!_vm.isLoadingFiltered ? _c("span", {
    key: "number",
    staticClass: "filtered-info-number"
  }, [_vm._v(_vm._s(_vm.filteredOverdueApplications))]) : _c("span", {
    key: "loading",
    staticClass: "filtered-info-loading"
  }, [_c("i", {
    staticClass: "fas fa-spinner fa-spin"
  })])])], 1)])])]), _vm._v(" "), _c("div", {
    staticClass: "applications-list",
    on: {
      scroll: _vm.onScroll
    }
  }, [_vm._l(_vm.filteredApplications, function (app) {
    return _c("div", {
      key: app.id,
      staticClass: "application-item clickable",
      on: {
        click: function click($event) {
          return _vm.openApplicationModal(app);
        }
      }
    }, [_c("div", {
      staticClass: "item-header"
    }, [_c("div", {
      staticClass: "header-left"
    }, [_c("strong", {
      staticClass: "prescription-name"
    }, [_vm._v("Prescrição: " + _vm._s(app.nome))])]), _vm._v(" "), _c("div", {
      staticClass: "header-right"
    }, [_c("div", {
      staticClass: "tags-container"
    }, [_c("span", {
      staticClass: "tag is-light category-tag"
    }, [_vm._v(_vm._s(app.categoria))]), _vm._v(" "), app.status ? _c("span", {
      staticClass: "tag status-tag",
      class: _vm.getStatusClass(app.status, app.dataAplicacao)
    }, [_vm._v(_vm._s(_vm.getStatusLabel(app.status, app.dataAplicacao)))]) : _vm._e()])])]), _vm._v(" "), _c("div", {
      staticClass: "item-details"
    }, [_c("div", {
      staticClass: "detail-row"
    }, [_c("strong", [_vm._v("Local:")]), _vm._v(" " + _vm._s(app.lote ? app.lote + " - " : "") + _vm._s(app.setor) + "\n                ")]), _vm._v(" "), _c("div", {
      staticClass: "detail-row"
    }, [_c("strong", [_vm._v("Data de aplicação:")]), _vm._v(" " + _vm._s(_vm.formatDate(app.dataAplicacao)) + "\n                ")]), _vm._v(" "), app.user ? _c("div", {
      staticClass: "detail-row"
    }, [_c("strong", [_vm._v("Coordenador:")]), _vm._v(" " + _vm._s(app.user) + "\n                ")]) : _vm._e(), _vm._v(" "), app.observation ? _c("div", {
      staticClass: "detail-row"
    }, [_c("strong", [_vm._v("Observação:")]), _vm._v(" "), _c("span", {
      staticClass: "observation-preview",
      attrs: {
        title: app.observation
      }
    }, [_vm._v("\n                    " + _vm._s(app.observation.length > 50 ? app.observation.substring(0, 50) + "..." : app.observation) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), app.description ? _c("div", {
      staticClass: "item-description"
    }, [_c("strong", [_vm._v("Descrição:")]), _vm._v(" "), _c("span", {
      staticClass: "description-text truncated",
      attrs: {
        title: app.description
      }
    }, [_vm._v("\n                  " + _vm._s(app.description.length > 100 ? app.description.substring(0, 100) : app.description) + "\n                ")])]) : _vm._e()]);
  }), _vm._v(" "), _vm.pagination.loading ? _c("div", {
    staticClass: "loading-more"
  }, [_c("p", [_vm._v("Carregando mais aplicações...")])]) : _vm._e(), _vm._v(" "), !_vm.pagination.hasMore && _vm.filteredApplications.length > 0 ? _c("div", {
    staticClass: "end-of-data"
  }, [_c("p", [_vm._v("Não há mais aplicações")])]) : _vm._e()], 2)])])]), _vm._v(" "), _c("ApplicationDetailsModal", {
    attrs: {
      visible: _vm.showApplicationModal,
      application: _vm.selectedApplication ? _vm.transformApplicationForModal(_vm.selectedApplication) : null
    },
    on: {
      close: function close($event) {
        _vm.showApplicationModal = false;
      },
      "start-application": _vm.startApplication,
      "update-status": _vm.openStatusUpdateModal,
      "resume-application": _vm.resumeApplication
    }
  })], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;